import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectBalloonContentInfo, selectBalloonContentLevelType, } from "../../selectors/selectBalloonInfo";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { DialogFarmEvent } from "../generic/farm-event/DialogFarmEvent";
import { BalloonOfferDetails } from "./BalloonOfferDetails";
var _DialogBalloonOffer = function (_a) {
    var balloonOfferContent = _a.balloonOfferContent, balloonOfferLevelType = _a.balloonOfferLevelType;
    if (balloonOfferContent == undefined || balloonOfferLevelType == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DialogFarmEvent, { eventTitleLoca: balloonOfferContent.locaKeyTitle, eventDescriptionLoca: balloonOfferContent.locaKeyDesc, eventCharacter: IdBigCharacter.BigCharacter_Montgomery, eventCharacterClassName: "flex__full", eventDescriptionStyleId: IdStyles.BalloonOfferContainerDescription },
        React.createElement("div", { className: "balloon-cloud balloon-cloud_1" }),
        React.createElement("div", { className: "balloon-cloud balloon-cloud_2" }),
        React.createElement(BalloonOfferDetails, { balloonOfferContent: balloonOfferContent, balloonOfferLevelType: balloonOfferLevelType })));
};
var mapState = function (state) {
    var balloonOfferContent = selectBalloonContentInfo(state);
    var balloonOfferLevelType = selectBalloonContentLevelType(state, balloonOfferContent);
    return {
        balloonOfferContent: balloonOfferContent,
        balloonOfferLevelType: balloonOfferLevelType,
    };
};
export var DialogBalloonOffer = connect(mapState)(_DialogBalloonOffer);



//////////////////
// WEBPACK FOOTER
// ./src/features/balloon/DialogBalloonOffer.tsx
// module id = 2550
// module chunks = 3